/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Block to render text with conflict description
 *
 * @author Anton Panasenko
 * @version 1.3.2
 * @since 1.3.0
 */

import { Fragment } from 'react';

import { EColorStatus } from '../../../../modules/app/appConstants';
import getCellValue from '../../helpers/getCellValue';
import {
    TableConflictStyled,
    TableTextDefaultValueStyled,
    TableTextStyled,
    TableTextTooltipStyled,
} from './styled/TableBlockStyled';

interface ITableConflictBlock {
    conflict?: string;
    colorState?: EColorStatus.SUCCESS | EColorStatus.ERROR;
    defaultValue: string;
    value: string;
}

export const TableTextConflictBlock = (props: ITableConflictBlock) => {
    const value = getCellValue(props.value);
    return (
    <Fragment>
        {
            value || props.conflict ?
                <Fragment>
                    <TableTextTooltipStyled>
                        <TableTextStyled colorState={props.colorState}>
                            {value ? value : <br/>}
                        </TableTextStyled>
                    </TableTextTooltipStyled>

                    <TableTextTooltipStyled>
                        <TableConflictStyled>
                            {props.conflict ? props.conflict : <br/>}
                        </TableConflictStyled>
                    </TableTextTooltipStyled>
                </Fragment>
                :
                <TableTextDefaultValueStyled>
                    {props.defaultValue}
                </TableTextDefaultValueStyled>
        }
    </Fragment>
)}
